export const onProgress = (event) => {
    const {loaded, total, type} = event;
    let progress
    if (type === 'progress' && total) {
        progress = Math.floor((loaded * 100) / total);
    }

    return {progress}
}